// extracted by css-extract-rspack-plugin
export default {"loader-wrapper":"VacancyListTab-module__loader-wrapper--D5YHy","loaderWrapper":"VacancyListTab-module__loader-wrapper--D5YHy"};